import LcAvatar from "./LcAvatar";

export { LcAvatar };
export default LcAvatar;
